export default __webpack_public_path__ + "static/media/Surtidora.bad70c6e.png";